import { isNull } from '../izUtils'

export const fieldsHistory = (historyForFields, responseHistory, transformedData, component) => {
    let componentHistory = {};
    let responseHistoryRev = responseHistory.reverse();

    historyForFields.forEach(field => {
        let fieldHistory = [];

        for (let i = 0; i < responseHistoryRev.length; i++) {
            if (!isNull(responseHistoryRev[i][component]) && !isNull(responseHistoryRev[i][component][field])) {
                if (i !== 0) {
                    const valCurr = responseHistoryRev[i][component][field];
                    const valPrev = responseHistoryRev[i-1][component][field];

                    if ((valCurr || valPrev) && (valCurr !== valPrev)) {
                        fieldHistory.push({
                            newValue: valCurr,
                            oldValue: valPrev,
                            createdAt: responseHistoryRev[i][component].updated_at,
                            changedBy: responseHistoryRev[i-1].user?.name,
                        });
                    }
                }
            }
        }

        // Check current input value against last history entry
        if (responseHistoryRev.length > 0) {
            const currentValue = transformedData?.[field]?.value;
            const lastHistoryValue = responseHistoryRev[responseHistoryRev?.length - 1][component][field];

            if ((currentValue || lastHistoryValue) && (currentValue !== lastHistoryValue)) {
                fieldHistory.push({
                    newValue: currentValue,
                    oldValue: lastHistoryValue,
                    createdAt: responseHistoryRev[responseHistoryRev.length - 1].created_at,
                    changedBy: responseHistoryRev[responseHistoryRev.length - 1].user?.name,
                });
            }
        }

        componentHistory[field] = fieldHistory;
    });

    return componentHistory;
}